import { SelectOption } from '@tryhackme/thm-ui-components';

import { CompanyItem } from './corporate.types';

export const COMPANY_ID_URL_QUERY_PARAM = 'id';

export const SelectOptions = [
  {
    id: '1',
    value: '10',
    label: '10',
  },
  {
    id: '2',
    value: '25',
    label: '25',
  },
  {
    id: '3',
    value: '100',
    label: '100',
  },
];

export const SeatType: SelectOption[] = [
  {
    id: '1',
    value: 'regular',
    label: 'Regular',
  },
  {
    id: '2',
    value: 'aws',
    label: 'AWS',
  },
  {
    id: '3',
    value: 'azure',
    label: 'Azure',
  },
];

export const defaultOption: SelectOption = { id: '1', value: '10', label: '10' };
export const validSortValues = ['-username', '-email', '-subExpiry', '-id', '-added'];
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion -- our input does not accept readonly options ATM
export const defaultSeatType: SelectOption = SeatType[0]!;
export const defaultCompany: SelectOption = { id: '', value: '', label: '' };
export const defaultCompanyDetails: CompanyItem = {
  _id: '',
  name: '',
  logo: '',
  deadline: '',
  isExpired: false,
  isTrial: false,
  type: 'b2b',
  tokens: { amount: 0 },
};
export const defaultUsersData = { totalDocs: '0', users: [] };

export const planInfo =
  'This will renew a management dashboards deadline and all seats (including user subscriptions); all seats on this plan will end on the same day.';

export const planWarning =
  "If a management dashboard has already expired, and their seats have been removed, you'll need to re-add the seats and manually extend the dashboards deadline! Do not use this modal as seats won't be added.";

export const companyTypeOptions = [
  { value: 'edu', label: 'EDU' },
  { value: 'b2b', label: 'B2B' },
];
